import { FC, HTMLAttributes, useEffect, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./Snackbar.style";
import { Icon } from "../../core/Icon/Icon";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Typography } from "../Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { resetAlertState } from "../../../store/slices/alert";

interface ITabsProps {
  autoHideDuration?: number;
}

export const Snackbar: FC<ITabsProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { autoHideDuration = 4000, ...otherProps } = props;
  const dispatch = useAppDispatch();
  const { message, data } = useAppSelector((state) => state.alert);
  const [isHideSnackbar, setHideSnackbar] = useState(false);

  const onCopyMessage = () => {
    if (data) {
      navigator.clipboard.writeText(data);
    }
  };

  useEffect(() => {
    let timeoutHide: NodeJS.Timeout;
    if (message) {
      timeoutHide = setTimeout(() => {
        dispatch(resetAlertState());
        setHideSnackbar(true);
      }, autoHideDuration);
    }
    return () => {
      clearTimeout(timeoutHide);
    };
  }, [autoHideDuration, dispatch, message]);

  return (
    <div
      {...otherProps}
      className={clsx(
        classes.root,
        isHideSnackbar && classes.hide,
        !!message && classes.show,
      )}
    >
      <div className={classes.content}>
        <Typography variant={TypographyVariant.BodyB5Bold} lines={2}>
          {message}
        </Typography>
      </div>
      {data && (
        <Icon
          name="icon-copy"
          className={classes.icon}
          onClick={onCopyMessage}
        />
      )}
    </div>
  );
};

Snackbar.defaultProps = {
  autoHideDuration: 4000,
};
